import { Badge } from "@common/index";
import { ComponentSize } from "@common/types";
import type { OrganizationStatus } from "@models/organization";
import { STATUS_META } from "./status";

interface StatusBadgeProps {
    status: OrganizationStatus;
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
    const { label, color } = STATUS_META[status];

    return (
        <Badge color={color} size={ComponentSize.SM}>
            {label}
        </Badge>
    );
};
